export const threatGroupKeys = {
  all: ["threatGroup"] as const,
  group: (threatGroupId: string) => [...threatGroupKeys.all, "group", threatGroupId] as const,
};
